// extracted by mini-css-extract-plugin
export default {"company":"app-layout_company--cSK56","wrapper":"app-layout_wrapper--BSpVd"};